import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import configureAppStore from '@stores/cartStore';
import { Provider } from 'react-redux';
import MinicartBody from '@components/cart/Minicart/MinicartBody';

const Minicart = () => {
	return (
		<Provider store={configureAppStore(window.pageContext)}>
			<MinicartBody minicart />
		</Provider>
	);
};

ReactDOM.render(
	<Sentry.ErrorBoundary>
		<Minicart />
	</Sentry.ErrorBoundary>,
	document.getElementById('rootMiniCart')
);
